<template lang="pug">
div
  div.row
    div.col-6
      h5 退藥理由
        button.btn.btn-sm.btn-info.icon-right(@click="createReason = !createReason") 新增退藥理由
      transition(name="slide-fade")
        div.create-form(v-if="createReason")
          div.form-inline
            input.form-control.mr-2(type="text" v-model="reason" placeholder="輸入欲新增理由")
            button.btn.btn-primary(@click="addReason") 新增

      table.table.table-striped
        thead
          tr 
            th 理由
            th 動作
        tbody
          tr(v-for="reason, ind in returnReason")
            th {{reason}}
            th 
              button.btn.btn-sm.btn-danger(@click="deleteReason(ind)") 刪除

</template>

<script>
export default {
  name: 'GeneralSetting',
  data() {
    return {
      createReason: false,
      reason: '',
    };
  },
  async created() {
    //
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    generalSetting() {
      return this.$store.state.generalSetting;
    },
    returnReason() {
      return this.$store.state.generalSetting.return_reason;
    },
  },
  methods: {
    async addReason() {
      const reasons = this.returnReason.join(';');
      console.log(this.returnReason, reasons);
      this.instance.patch(`/api/general-setting/${this.generalSetting.id}/`, {
        return_reason: reasons.concat(`;${this.reason}`),
      })
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功',
        });
        this.$store.dispatch('getSystemInfo');
        this.createReason = false;
      });
    },
    async deleteReason(ind) {
      console.log(this.returnReason.splice(ind, 1));
      this.instance.patch(`/api/general-setting/${this.generalSetting.id}/`, {
        return_reason: this.returnReason.join(';'),
      })
      .then(() => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        this.$store.dispatch('getSystemInfo');
      });
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// GeneralSettings.vue?fc481a94